if (!customElements.get('search-paper')) {
  class searchPaper extends HTMLElement {
      constructor() {
          super();
          let that=this;
          const isPC=window.innerWidth>768;
          this.searchInput=this.querySelector("#search-paper-input")
          this.collectionTab=isPC?this.querySelectorAll('.tab-collection-wrapper'):this.querySelectorAll('.navList')
          this.collectionTabEl=isPC?this.querySelector(".filter_warpper_tab_pc"):this.querySelector(".filter_warpper_tab_moblie")
          this.prodWrapper=isPC?this.querySelector(".products"):this.querySelector(".filter-moblie-wrapper-content")
          this.noResultEl=isPC?this.querySelector(".noResultText"):this.querySelector(".noResultText_Mobile")
          this.prodListContainer=isPC?this.querySelectorAll(".tab-product"):this.querySelectorAll(".tab-product-moblie")
          this.prodListContainerData=[]
          this.backTextEl=this.querySelector(".backText")
          this.scrollContent=this.querySelector("#scrollContentInner")
          this.arrow_left_btn=this.querySelector(".arrow_left")
          this.arrow_right_btn=this.querySelector(".arrow_right")
          this.sreachBtn=this.querySelector(".sreachBtn")
          this.activeTab=this.querySelector(".active").dataset.tabName;
          this.collectionTabFn(this.activeTab)
          this.searchInput.addEventListener("keyup",function(e){
              if(!e.target.value){
                that.collectionTabFn(that.activeTab)
              }
          })
          this.prodListContainer.forEach((item)=>{
            item.addEventListener("click",function(e){
              that.goPage(e.currentTarget.dataset.url)
            })
            this.prodListContainerData.push({
              "title":item.dataset.title,
              "prodindex":item.dataset.tabIndex,
            })
          })
          this.sreachBtn.addEventListener("click",function(e){
            that.searchPaperFn(that.searchInput.value)
          })
          
          this.collectionTab.forEach((item)=>{
            item.addEventListener("click",function(e){
              that.collectionTabFn(e.currentTarget.dataset.tabName)
            })
          })
          this.backTextEl.addEventListener("click",function(e){
            that.searchInput.value="";
            that.collectionTabFn(that.activeTab)
          })
          this.arrow_left_btn.addEventListener("click",function(e){
            that.scrollLeft()
          })
          this.arrow_right_btn.addEventListener("click",function(e){
            that.scrollRight()
          })
          const handleScrollEnd = () => {
            that.isShowArrowFn();
          };
          if(isPC){
            this.scrollContent.addEventListener('scrollend', handleScrollEnd);
          }
      }
      searchPaperFn(keyword){
        keyword=keyword.toUpperCase().replace(/\s/g, ''); 
        let fullResult=this.prodListContainerData.filter(item=>keyword===item.title.replace(/\s/g, ''));
        let includeResult=this.prodListContainerData.filter(item=>item.title.toUpperCase().replace(/\s/g, '').includes(keyword));
        let includeResult2=this.prodListContainerData.filter(item=>keyword.includes(item.title.toUpperCase().replace(/\s/g, '')));
        let sreachResult=fullResult.concat(includeResult).concat(includeResult2);
        if(sreachResult.length==0){
          this.ResultFN(false)
          return
        }
        this.ResultFN(true)
        this.prodListContainer.forEach((item)=>{
          if(sreachResult.findIndex(citem=>citem.prodindex==item.dataset.tabIndex)>-1){
            item.style.display="block"
          }else{
            item.style.display="none"
          }
        })
      }
      collectionTabFn(index){
        this.ResultFN(true,1)
        this.activeTab=index;
        this.collectionTab.forEach((item)=>{
          if(item.dataset.tabName==this.activeTab){
            item.classList.add("active")
          }else{
            item.classList.remove("active")
          }
        })
        this.prodListContainer.forEach((item)=>{
          if(item.dataset.tabName==index){
            item.style.display="block"
          }else{
            item.style.display="none"
          }
        })
      }
      isShowArrowFn(){
        if(this.scrollContent.scrollLeft==0){
          this.arrow_left_btn.classList.add("hide")
        }else{
          this.arrow_left_btn.classList.remove("hide")
        }
        if(this.scrollContent.scrollLeft+this.scrollContent.clientWidth>=this.scrollContent.scrollWidth){
          this.arrow_right_btn.classList.add("hide")
        }else{
          this.arrow_right_btn.classList.remove("hide")
        }
      }
      scrollLeft() {
        if (this.scrollContent.scrollTo) {
          this.scrollContent.scrollTo({
            left: this.scrollContent.scrollLeft - this.scrollContent.clientWidth,
            behavior: 'smooth'
          });
        } else {
            this.scrollContent.scrollLeft -= this.scrollContent.clientWidth;
        }
      }
      scrollRight() {
        if (this.scrollContent.scrollTo) {
          this.scrollContent.scrollTo({
            left: this.scrollContent.scrollLeft + this.scrollContent.clientWidth,
            behavior: 'smooth'
          });
        } else {
            this.scrollContent.scrollLeft += this.scrollContent.clientWidth;
        }
      }
      ResultFN(hasResult,type){
        this.prodWrapper.style.display=hasResult?"flex":"none";
        this.collectionTabEl.style.display=hasResult&!type?"none":"flex";
        this.noResultEl.style.display=hasResult?"none":"block";
        this.backTextEl.style.display=hasResult&!type?"flex":"none";
        
        setTimeout(()=>{
          this.isShowArrowFn()
        },60)
      }
      goPage(url){
        window.location.href=window.location.origin+url;
      }
  }
  customElements.define('search-paper', searchPaper);
}
   